webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(13),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TableContent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TableContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TableContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verbs_json__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verbs_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__verbs_json__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TableContent: __WEBPACK_IMPORTED_MODULE_0__components_TableContent___default.a
  },
  data: function data() {
    return {
      verbs: __WEBPACK_IMPORTED_MODULE_1__verbs_json___default.a
    };
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableItem__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TableItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tableContent',
  components: {
    TableItem: __WEBPACK_IMPORTED_MODULE_0__TableItem___default.a
  },
  data: function data() {
    return {
      search_field: '',
      is_search: false
    };
  },

  props: ['data'],
  computed: {
    filteredVerbs: function filteredVerbs() {
      var _this = this;

      return this.data.filter(function (value) {
        return value.searchedfield.toLowerCase().indexOf(_this.search_field.toLowerCase()) >= 0;
      });
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tableItem',
  props: ['items']

});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(12),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(14),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("Find your verb")]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui icon massive input loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_field),
      expression: "search_field"
    }],
    staticClass: "search loading",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search_field)
    },
    on: {
      "keyup": function($event) {
        _vm.is_search = false
      },
      "keydown": function($event) {
        _vm.is_search = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_field = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.is_search) ? _c('i', {
    staticClass: "search icon"
  }) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredVerbs), function(item) {
    return _c('table-item', {
      key: item.base_form,
      attrs: {
        "items": item
      }
    })
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Base form")]), _vm._v(" "), _c('th', [_vm._v("Past Simple (V2)")]), _vm._v(" "), _c('th', [_vm._v("Past Participle (V3)")])])
}]}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('table-content', {
    attrs: {
      "data": _vm.verbs
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n    " + _vm._s(_vm.items.base) + "\n  ")]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.items.past_simple) + "\n  ")]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(_vm.items.past_participle) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = [
	{
		"base": "arise",
		"past_simple": "arose",
		"past_participle": "arisen",
		"searchedfield": "arisearosearisen"
	},
	{
		"base": "awake",
		"past_simple": "awoke",
		"past_participle": "awoken",
		"searchedfield": "awakeawokeawoken"
	},
	{
		"base": "be",
		"past_simple": "was/were",
		"past_participle": "been",
		"searchedfield": "bewas/werebeen"
	},
	{
		"base": "bear",
		"past_simple": "bore",
		"past_participle": "born(e)",
		"searchedfield": "bearboreborn(e)"
	},
	{
		"base": "beat",
		"past_simple": "beat",
		"past_participle": "beaten",
		"searchedfield": "beatbeatbeaten"
	},
	{
		"base": "become",
		"past_simple": "became",
		"past_participle": "become",
		"searchedfield": "becomebecamebecome"
	},
	{
		"base": "begin",
		"past_simple": "began",
		"past_participle": "begun",
		"searchedfield": "beginbeganbegun"
	},
	{
		"base": "bend",
		"past_simple": "bent",
		"past_participle": "bent",
		"searchedfield": "bendbentbent"
	},
	{
		"base": "bet",
		"past_simple": "bet",
		"past_participle": "bet",
		"searchedfield": "betbetbet"
	},
	{
		"base": "bind",
		"past_simple": "bound",
		"past_participle": "bound",
		"searchedfield": "bindboundbound"
	},
	{
		"base": "bite",
		"past_simple": "bit",
		"past_participle": "bitten",
		"searchedfield": "bitebitbitten"
	},
	{
		"base": "bleed",
		"past_simple": "bled",
		"past_participle": "bled",
		"searchedfield": "bleedbledbled"
	},
	{
		"base": "blow",
		"past_simple": "blew",
		"past_participle": "blown",
		"searchedfield": "blowblewblown"
	},
	{
		"base": "break",
		"past_simple": "broke",
		"past_participle": "broken",
		"searchedfield": "breakbrokebroken"
	},
	{
		"base": "breed",
		"past_simple": "bred",
		"past_participle": "bred",
		"searchedfield": "breedbredbred"
	},
	{
		"base": "bring",
		"past_simple": "brought",
		"past_participle": "brought",
		"searchedfield": "bringbroughtbrought"
	},
	{
		"base": "broadcast",
		"past_simple": "broadcast",
		"past_participle": "broadcast",
		"searchedfield": "broadcastbroadcastbroadcast"
	},
	{
		"base": "build",
		"past_simple": "built",
		"past_participle": "built",
		"searchedfield": "buildbuiltbuilt"
	},
	{
		"base": "burn",
		"past_simple": "burnt/burned",
		"past_participle": "burnt/burned",
		"searchedfield": "burnburnt/burnedburnt/burned"
	},
	{
		"base": "burst",
		"past_simple": "burst",
		"past_participle": "burst",
		"searchedfield": "burstburstburst"
	},
	{
		"base": "buy",
		"past_simple": "bought",
		"past_participle": "bought",
		"searchedfield": "buyboughtbought"
	},
	{
		"base": "can",
		"past_simple": "could",
		"past_participle": "… (been able)",
		"searchedfield": "cancould… (been able)"
	},
	{
		"base": "catch",
		"past_simple": "caught",
		"past_participle": "caught",
		"searchedfield": "catchcaughtcaught"
	},
	{
		"base": "choose",
		"past_simple": "chose",
		"past_participle": "chosen",
		"searchedfield": "choosechosechosen"
	},
	{
		"base": "cling",
		"past_simple": "clung",
		"past_participle": "clung",
		"searchedfield": "clingclungclung"
	},
	{
		"base": "come",
		"past_simple": "came",
		"past_participle": "come",
		"searchedfield": "comecamecome"
	},
	{
		"base": "cost",
		"past_simple": "cost",
		"past_participle": "cost",
		"searchedfield": "costcostcost"
	},
	{
		"base": "creep",
		"past_simple": "crept",
		"past_participle": "crept",
		"searchedfield": "creepcreptcrept"
	},
	{
		"base": "cut",
		"past_simple": "cut",
		"past_participle": "cut",
		"searchedfield": "cutcutcut"
	},
	{
		"base": "deal",
		"past_simple": "dealt",
		"past_participle": "dealt",
		"searchedfield": "dealdealtdealt"
	},
	{
		"base": "dig",
		"past_simple": "dug",
		"past_participle": "dug",
		"searchedfield": "digdugdug"
	},
	{
		"base": "do",
		"past_simple": "did",
		"past_participle": "done",
		"searchedfield": "dodiddone"
	},
	{
		"base": "draw",
		"past_simple": "drew",
		"past_participle": "drawn",
		"searchedfield": "drawdrewdrawn"
	},
	{
		"base": "dream",
		"past_simple": "dreamt/dreamed",
		"past_participle": "dreamt/dreamed",
		"searchedfield": "dreamdreamt/dreameddreamt/dreamed"
	},
	{
		"base": "drink",
		"past_simple": "drank",
		"past_participle": "drunk",
		"searchedfield": "drinkdrankdrunk"
	},
	{
		"base": "drive",
		"past_simple": "drove",
		"past_participle": "driven",
		"searchedfield": "drivedrovedriven"
	},
	{
		"base": "eat",
		"past_simple": "ate",
		"past_participle": "eaten",
		"searchedfield": "eatateeaten"
	},
	{
		"base": "fall",
		"past_simple": "fell",
		"past_participle": "fallen",
		"searchedfield": "fallfellfallen"
	},
	{
		"base": "feed",
		"past_simple": "fed",
		"past_participle": "fed",
		"searchedfield": "feedfedfed"
	},
	{
		"base": "feel",
		"past_simple": "felt",
		"past_participle": "felt",
		"searchedfield": "feelfeltfelt"
	},
	{
		"base": "fight",
		"past_simple": "fought",
		"past_participle": "fought",
		"searchedfield": "fightfoughtfought"
	},
	{
		"base": "find",
		"past_simple": "found",
		"past_participle": "found",
		"searchedfield": "findfoundfound"
	},
	{
		"base": "fly",
		"past_simple": "flew",
		"past_participle": "flown",
		"searchedfield": "flyflewflown"
	},
	{
		"base": "forbid",
		"past_simple": "forbade",
		"past_participle": "forbidden",
		"searchedfield": "forbidforbadeforbidden"
	},
	{
		"base": "forget",
		"past_simple": "forgot",
		"past_participle": "forgotten",
		"searchedfield": "forgetforgotforgotten"
	},
	{
		"base": "forgive",
		"past_simple": "forgave",
		"past_participle": "forgiven",
		"searchedfield": "forgiveforgaveforgiven"
	},
	{
		"base": "freeze",
		"past_simple": "froze",
		"past_participle": "frozen",
		"searchedfield": "freezefrozefrozen"
	},
	{
		"base": "get",
		"past_simple": "got",
		"past_participle": "got",
		"searchedfield": "getgotgot"
	},
	{
		"base": "give",
		"past_simple": "gave",
		"past_participle": "given",
		"searchedfield": "givegavegiven"
	},
	{
		"base": "go",
		"past_simple": "went",
		"past_participle": "gone",
		"searchedfield": "gowentgone"
	},
	{
		"base": "grind",
		"past_simple": "ground",
		"past_participle": "ground",
		"searchedfield": "grindgroundground"
	},
	{
		"base": "grow",
		"past_simple": "grew",
		"past_participle": "grown",
		"searchedfield": "growgrewgrown"
	},
	{
		"base": "hang",
		"past_simple": "hung",
		"past_participle": "hung",
		"searchedfield": "hanghunghung"
	},
	{
		"base": "have",
		"past_simple": "had",
		"past_participle": "had",
		"searchedfield": "havehadhad"
	},
	{
		"base": "hear",
		"past_simple": "heard",
		"past_participle": "heard",
		"searchedfield": "hearheardheard"
	},
	{
		"base": "hide",
		"past_simple": "hid",
		"past_participle": "hidden",
		"searchedfield": "hidehidhidden"
	},
	{
		"base": "hit",
		"past_simple": "hit",
		"past_participle": "hit",
		"searchedfield": "hithithit"
	},
	{
		"base": "hold",
		"past_simple": "held",
		"past_participle": "held",
		"searchedfield": "holdheldheld"
	},
	{
		"base": "hurt",
		"past_simple": "hurt",
		"past_participle": "hurt",
		"searchedfield": "hurthurthurt"
	},
	{
		"base": "keep",
		"past_simple": "kept",
		"past_participle": "kept",
		"searchedfield": "keepkeptkept"
	},
	{
		"base": "kneel",
		"past_simple": "knelt",
		"past_participle": "knelt",
		"searchedfield": "kneelkneltknelt"
	},
	{
		"base": "know",
		"past_simple": "knew",
		"past_participle": "known",
		"searchedfield": "knowknewknown"
	},
	{
		"base": "lay",
		"past_simple": "laid",
		"past_participle": "laid",
		"searchedfield": "laylaidlaid"
	},
	{
		"base": "lead",
		"past_simple": "led",
		"past_participle": "led",
		"searchedfield": "leadledled"
	},
	{
		"base": "lean",
		"past_simple": "leant/leaned",
		"past_participle": "leant/leaned",
		"searchedfield": "leanleant/leanedleant/leaned"
	},
	{
		"base": "learn",
		"past_simple": "learnt/learned",
		"past_participle": "learnt/learned",
		"searchedfield": "learnlearnt/learnedlearnt/learned"
	},
	{
		"base": "leave",
		"past_simple": "left",
		"past_participle": "left",
		"searchedfield": "leaveleftleft"
	},
	{
		"base": "lent",
		"past_simple": "lent",
		"past_participle": "lent",
		"searchedfield": "lentlentlent"
	},
	{
		"base": "lie (in bed)",
		"past_simple": "lay",
		"past_participle": "lain",
		"searchedfield": "lie (in bed)laylain"
	},
	{
		"base": "lie (to not tell the truth)",
		"past_simple": "lied",
		"past_participle": "lied",
		"searchedfield": "lie (to not tell the truth)liedlied"
	},
	{
		"base": "light",
		"past_simple": "lit/lighted",
		"past_participle": "lit/lighted",
		"searchedfield": "lightlit/lightedlit/lighted"
	},
	{
		"base": "lose",
		"past_simple": "lost",
		"past_participle": "lost",
		"searchedfield": "loselostlost"
	},
	{
		"base": "make",
		"past_simple": "made",
		"past_participle": "made",
		"searchedfield": "makemademade"
	},
	{
		"base": "may",
		"past_simple": "might",
		"past_participle": "…",
		"searchedfield": "maymight…"
	},
	{
		"base": "mean",
		"past_simple": "meant",
		"past_participle": "meant",
		"searchedfield": "meanmeantmeant"
	},
	{
		"base": "meet",
		"past_simple": "met",
		"past_participle": "met",
		"searchedfield": "meetmetmet"
	},
	{
		"base": "mow",
		"past_simple": "mowed",
		"past_participle": "mown/mowed",
		"searchedfield": "mowmowedmown/mowed"
	},
	{
		"base": "must",
		"past_simple": "had to",
		"past_participle": "…",
		"searchedfield": "musthad to…"
	},
	{
		"base": "overtake",
		"past_simple": "overtook",
		"past_participle": "overtaken",
		"searchedfield": "overtakeovertookovertaken"
	},
	{
		"base": "pay",
		"past_simple": "paid",
		"past_participle": "paid",
		"searchedfield": "paypaidpaid"
	},
	{
		"base": "put",
		"past_simple": "put",
		"past_participle": "put",
		"searchedfield": "putputput"
	},
	{
		"base": "read",
		"past_simple": "read",
		"past_participle": "read",
		"searchedfield": "readreadread"
	},
	{
		"base": "ride",
		"past_simple": "rode",
		"past_participle": "ridden",
		"searchedfield": "rideroderidden"
	},
	{
		"base": "ring",
		"past_simple": "rang",
		"past_participle": "rung",
		"searchedfield": "ringrangrung"
	},
	{
		"base": "rise",
		"past_simple": "rose",
		"past_participle": "risen",
		"searchedfield": "riseroserisen"
	},
	{
		"base": "run",
		"past_simple": "ran",
		"past_participle": "run",
		"searchedfield": "runranrun"
	},
	{
		"base": "saw",
		"past_simple": "sawed",
		"past_participle": "sawn/sawed",
		"searchedfield": "sawsawedsawn/sawed"
	},
	{
		"base": "say",
		"past_simple": "said",
		"past_participle": "said",
		"searchedfield": "saysaidsaid"
	},
	{
		"base": "see",
		"past_simple": "saw",
		"past_participle": "seen",
		"searchedfield": "seesawseen"
	},
	{
		"base": "sell",
		"past_simple": "sold",
		"past_participle": "sold",
		"searchedfield": "sellsoldsold"
	},
	{
		"base": "send",
		"past_simple": "sent",
		"past_participle": "sent",
		"searchedfield": "sendsentsent"
	},
	{
		"base": "set",
		"past_simple": "set",
		"past_participle": "set",
		"searchedfield": "setsetset"
	},
	{
		"base": "sew",
		"past_simple": "sewed",
		"past_participle": "sewn/sewed",
		"searchedfield": "sewsewedsewn/sewed"
	},
	{
		"base": "shake",
		"past_simple": "shook",
		"past_participle": "shaken",
		"searchedfield": "shakeshookshaken"
	},
	{
		"base": "shall",
		"past_simple": "should",
		"past_participle": "…",
		"searchedfield": "shallshould…"
	},
	{
		"base": "shed",
		"past_simple": "shed",
		"past_participle": "shed",
		"searchedfield": "shedshedshed"
	},
	{
		"base": "shine",
		"past_simple": "shone",
		"past_participle": "shone",
		"searchedfield": "shineshoneshone"
	},
	{
		"base": "shoot",
		"past_simple": "shot",
		"past_participle": "shot",
		"searchedfield": "shootshotshot"
	},
	{
		"base": "show",
		"past_simple": "showed",
		"past_participle": "shown",
		"searchedfield": "showshowedshown"
	},
	{
		"base": "shrink",
		"past_simple": "shrank",
		"past_participle": "shrunk",
		"searchedfield": "shrinkshrankshrunk"
	},
	{
		"base": "shut",
		"past_simple": "shut",
		"past_participle": "shut",
		"searchedfield": "shutshutshut"
	},
	{
		"base": "sing",
		"past_simple": "sang",
		"past_participle": "sung",
		"searchedfield": "singsangsung"
	},
	{
		"base": "sink",
		"past_simple": "sank",
		"past_participle": "sunk",
		"searchedfield": "sinksanksunk"
	},
	{
		"base": "sit",
		"past_simple": "sat",
		"past_participle": "sat",
		"searchedfield": "sitsatsat"
	},
	{
		"base": "sleep",
		"past_simple": "slept",
		"past_participle": "slept",
		"searchedfield": "sleepsleptslept"
	},
	{
		"base": "slide",
		"past_simple": "slid",
		"past_participle": "slid",
		"searchedfield": "slideslidslid"
	},
	{
		"base": "smell",
		"past_simple": "smelt",
		"past_participle": "smelt",
		"searchedfield": "smellsmeltsmelt"
	},
	{
		"base": "sow",
		"past_simple": "sowed",
		"past_participle": "sown/sowed",
		"searchedfield": "sowsowedsown/sowed"
	},
	{
		"base": "speak",
		"past_simple": "spoke",
		"past_participle": "spoken",
		"searchedfield": "speakspokespoken"
	},
	{
		"base": "spell",
		"past_simple": "spelt/spelled",
		"past_participle": "spelt/spelled",
		"searchedfield": "spellspelt/spelledspelt/spelled"
	},
	{
		"base": "spend",
		"past_simple": "spent",
		"past_participle": "spent",
		"searchedfield": "spendspentspent"
	},
	{
		"base": "spill",
		"past_simple": "spilt/spilled",
		"past_participle": "spilt/spilled",
		"searchedfield": "spillspilt/spilledspilt/spilled"
	},
	{
		"base": "spit",
		"past_simple": "spat",
		"past_participle": "spat",
		"searchedfield": "spitspatspat"
	},
	{
		"base": "spread",
		"past_simple": "spread",
		"past_participle": "spread",
		"searchedfield": "spreadspreadspread"
	},
	{
		"base": "stand",
		"past_simple": "stood",
		"past_participle": "stood",
		"searchedfield": "standstoodstood"
	},
	{
		"base": "steal",
		"past_simple": "stole",
		"past_participle": "stolen",
		"searchedfield": "stealstolestolen"
	},
	{
		"base": "stick",
		"past_simple": "stuck",
		"past_participle": "stuck",
		"searchedfield": "stickstuckstuck"
	},
	{
		"base": "sting",
		"past_simple": "stung",
		"past_participle": "stung",
		"searchedfield": "stingstungstung"
	},
	{
		"base": "stink",
		"past_simple": "stank",
		"past_participle": "stunk",
		"searchedfield": "stinkstankstunk"
	},
	{
		"base": "strike",
		"past_simple": "struck",
		"past_participle": "struck",
		"searchedfield": "strikestruckstruck"
	},
	{
		"base": "swear",
		"past_simple": "swore",
		"past_participle": "sworn",
		"searchedfield": "swearsworesworn"
	},
	{
		"base": "sweep",
		"past_simple": "swept",
		"past_participle": "swept",
		"searchedfield": "sweepsweptswept"
	},
	{
		"base": "swell",
		"past_simple": "swelled",
		"past_participle": "swollen/swelled",
		"searchedfield": "swellswelledswollen/swelled"
	},
	{
		"base": "swim",
		"past_simple": "swam",
		"past_participle": "swum",
		"searchedfield": "swimswamswum"
	},
	{
		"base": "swing",
		"past_simple": "swung",
		"past_participle": "swung",
		"searchedfield": "swingswungswung"
	},
	{
		"base": "take",
		"past_simple": "took",
		"past_participle": "taken",
		"searchedfield": "taketooktaken"
	},
	{
		"base": "teach",
		"past_simple": "taught",
		"past_participle": "taught",
		"searchedfield": "teachtaughttaught"
	},
	{
		"base": "tear",
		"past_simple": "tore",
		"past_participle": "torn",
		"searchedfield": "teartoretorn"
	},
	{
		"base": "tell",
		"past_simple": "told",
		"past_participle": "told",
		"searchedfield": "telltoldtold"
	},
	{
		"base": "think",
		"past_simple": "thought",
		"past_participle": "thought",
		"searchedfield": "thinkthoughtthought"
	},
	{
		"base": "throw",
		"past_simple": "threw",
		"past_participle": "thrown",
		"searchedfield": "throwthrewthrown"
	},
	{
		"base": "understand",
		"past_simple": "understood",
		"past_participle": "understood",
		"searchedfield": "understandunderstoodunderstood"
	},
	{
		"base": "wake",
		"past_simple": "woke",
		"past_participle": "woken",
		"searchedfield": "wakewokewoken"
	},
	{
		"base": "wear",
		"past_simple": "wore",
		"past_participle": "worn",
		"searchedfield": "wearworeworn"
	},
	{
		"base": "weep",
		"past_simple": "wept",
		"past_participle": "wept",
		"searchedfield": "weepweptwept"
	},
	{
		"base": "will",
		"past_simple": "would",
		"past_participle": "…",
		"searchedfield": "willwould…"
	},
	{
		"base": "win",
		"past_simple": "won",
		"past_participle": "won",
		"searchedfield": "winwonwon"
	},
	{
		"base": "wind",
		"past_simple": "wound",
		"past_participle": "wound",
		"searchedfield": "windwoundwound"
	},
	{
		"base": "write",
		"past_simple": "wrote",
		"past_participle": "written",
		"searchedfield": "writewrotewritten"
	}
];

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.4d7874b23317b5bc2327.js